export * from "ce/components/RunHistory";
import { default as CE_RunHistory } from "ce/components/RunHistory";
export default CE_RunHistory;
